var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnimatedArrowCurrentColor = function SvgAnimatedArrowCurrentColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M0 0 10 10M0 10 h10 v-10",
    className: "animated-arrow-solid-line"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M0 0 10 10",
    className: "animated-arrow-animated-line"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "3s",
    keyTimes: "0;0.1333;0.3333;0.4666;1",
    repeatCount: "indefinite",
    values: "15,0; 0,15; 0,15; 15,0; 15,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "3s",
    keyTimes: "0;0.1333;0.3333;0.4666;1",
    repeatCount: "indefinite",
    values: "0; -15; -15; -15; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M0 10 h10 v-10",
    className: "animated-arrow-animated-line"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "3s",
    keyTimes: "0;0.1333;0.4;0.4666;0.7333;1",
    repeatCount: "indefinite",
    values: "22,0; 22,0; 0,22; 0,22; 22,0; 22,0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "3s",
    keyTimes: "0;0.1333;0.4;0.4666;0.7333;1",
    repeatCount: "indefinite",
    values: "0; 0; -22; -22; -22; 0"
  }))));
};
export default SvgAnimatedArrowCurrentColor;